module.exports = __webpack_public_path__ + "static/media/logo.05cfae81.png";